import { msg } from "@lingui/core/macro";

export const expiresSameDayRuleMessages = {
	name: msg({ message: "Expires Same Day" }),
	description: msg({ message: "Permit expiry date must be the same day as start date" }),
	errors: {
		noEndTime: msg({ message: "Permit must have an end time" }),
	},
} as const;
